/**
 * 产教融合路由
 */
const fusionRoutes = {
    name: 'fusionLayout',
    path: '/fusionLayout',
    component: () => import('@/layout/index.vue'),
    children: [
        {
            path: '/fusion',
            component: () => import('@/views/fusion/index.vue'),
            meta: {
                title: '产教融合'
            }
        },
        {
            path: '/fusion/notice',
            component: () => import('@/views/fusion/notice.vue'),
            meta: {
                title: '通知公告'
            }
        },
        {
            path: '/fusion/noticeDetail',
            component: () => import('@/views/fusion/noticeDetail.vue'),
            meta: {
                title: '通知公告详情'
            }
        },
        {
            path: '/fusion/dynamic',
            component: () => import('@/views/fusion/dynamic.vue'),
            meta: {
                title: '就业动态'
            }
        },
        {
            path: '/fusion/dynamicDetail',
            component: () => import('@/views/fusion/dynamicDetail.vue'),
            meta: {
                title: '动态详情'
            }
        },
        {
            path: '/fusion/source',
            component: () => import('@/views/fusion/source.vue'),
            meta: {
                title: '优秀生源'
            }
        },
        {
            path: '/fusion/alumnus',
            component: () => import('@/views/fusion/alumnus.vue'),
            meta: {
                title: '成员企业'
            }
        },
    ]
}

const fusionsWhite = [
    { path: '/fusion' },
    { path: '/fusion/notice' },
    { path: '/fusion/noticeDetail' },
    { path: '/fusion/dynamic' },
    { path: '/fusion/dynamicDetail' },
    { path: '/fusion/source' },
    { path: '/fusion/alumnus' },
]

export {
    fusionRoutes,
    fusionsWhite
}